"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationRpc = void 0;
var ConfigurationRpc;
(function (ConfigurationRpc) {
    let V1;
    (function (V1) {
        let Set;
        (function (Set) {
            Set.Method = 'v1.configuration.set';
        })(Set = V1.Set || (V1.Set = {}));
        let Get;
        (function (Get) {
            Get.Method = 'v1.configuration.get';
        })(Get = V1.Get || (V1.Get = {}));
    })(V1 = ConfigurationRpc.V1 || (ConfigurationRpc.V1 = {}));
    let V2;
    (function (V2) {
        let Set;
        (function (Set) {
            Set.Method = 'v2.configuration.set';
        })(Set = V2.Set || (V2.Set = {}));
        let Get;
        (function (Get) {
            Get.Method = 'v2.configuration.get';
        })(Get = V2.Get || (V2.Get = {}));
    })(V2 = ConfigurationRpc.V2 || (ConfigurationRpc.V2 = {}));
})(ConfigurationRpc || (exports.ConfigurationRpc = ConfigurationRpc = {}));
